import { render, staticRenderFns } from "./deleteNewsTable.vue?vue&type=template&id=19019b66&scoped=true"
import script from "./deleteNewsTable.vue?vue&type=script&lang=ts"
export * from "./deleteNewsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19019b66",
  null
  
)

export default component.exports